import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketManager } from "../..";

type Props = {
  reload?: () => void;
  sortManager: TicketManager;
  filterManager: TicketManager;
};

export const FilterSortTags = observer((props: Props) => {
  const t = useTranslation();

  return (
    <>
      {props.sortManager.getSortBy() && (
        <Tag
          style={{ marginBottom: 10 }}
          closeIcon={
            <Icon
              icon="fa:times"
              onClick={() => {
                props.sortManager.setSortBy(undefined);
                props.reload
                  ? props.reload()
                  : props.sortManager.fetchTickets();
              }}
            />
          }
        >
          {t("maintenance:settings.sortby.label")}:{" "}
          {props.sortManager.getSortBy() &&
            t(
              "maintenance:settings.sortby.options." +
                props.sortManager.getSortBy()
            )}
          {!props.sortManager.getSortBy() &&
            t("maintenance:settings.sortby.options.default")}
        </Tag>
      )}

      {props.filterManager.getFilters().map(([key, object]) => (
        <Tag
          key={key}
          style={{ marginBottom: 10 }}
          closeIcon={
            <Icon
              icon="fa:times"
              onClick={() => {
                props.filterManager.removeFilter(key);
                props.reload
                  ? props.reload()
                  : props.filterManager.fetchTickets();
              }}
            />
          }
        >
          {t("maintenance:settings.filterby." + object.attribute + ".label")}
        </Tag>
      ))}
    </>
  );
});
